import { ADDTOCART } from '../../constants/events';

const checkoutUrl = lng => {
  if (lng.indexOf('CH') > -1 || lng.indexOf('BE') > -1) {
    if (lng.indexOf('de') > -1) {
      return '/de';
    } else if (lng.indexOf('fr') > -1) {
      return '/fr';
    }
    return '/nl';
  }
  return '';
};

function buy(cfg, smp, lng) {
  const url = checkoutUrl(lng);
  return $.post(`${url}/checkout/cart/add`, {
    sku: [`${cfg};${smp}`],
    qty: 1
  }).then(res => {
    $.publish('update.header:cart', res.cartItemsCount);
    window.location.pathname = `${url}/checkout/cart`;
    return 'ADDED';
  });
}

export const removeEventListenerToBuyButton = selector => {
  const element = document.getElementById(selector);
  $(element).off();
};

const addEventListenerToBuyButton = ({
  selector,
  cfg,
  smp,
  price,
  name,
  variant,
  currencyCode,
  lng
}) => {
  const element = document.getElementById(selector);
  element.addEventListener('click', () => {
    buy(cfg, smp, lng).then(() => {
      dataLayer.push({
        event: ADDTOCART,
        ecommerce: {
          currencyCode,
          add: {
            products: [
              {
                name,
                id: smp,
                price,
                brand: '',
                category: '',
                dimension65: 'inline_qv',
                variant,
                quantity: 1
              }
            ]
          }
        }
      });
    });
  });
};

export default addEventListenerToBuyButton;



/** WEBPACK FOOTER **
 ** ./legacy/home24-shared/components/quickview/functions/eventListeners/buy.js
 **/